module.exports = __webpack_public_path__ + "static/img/man_top_box.fa42605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/gem/man_top_box.png
// module id = z/PV
// module chunks = 1